import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ApiConstants } from '../constants/api-constants';

export interface SectionHead {
  name: string;
}

export interface AttendanceDayTimes {
  checkInOpen: string;
  checkInLateAfter: string;
  checkOutOpen: string;
  checkOutLateAfter: string;
}

export interface AttendanceHolidayDate {
  name: string;
  date: string;
}

export interface AttendanceSchedule extends AttendanceDayTimes {
  lateEnabled: boolean;
  holidayWeekdays: number[];
  holidayDates: AttendanceHolidayDate[];
  byWeekday: Record<string, AttendanceDayTimes>;
}

export interface StudentCardColors {
  busBackground: string;
  noBusBackground: string;
  cutMarginMm: number;
}

export interface SchoolSettings {
  id?: string;
  schoolName: string;
  departmentName: string;
  headName: string;
  sectionHeads: SectionHead[];
  studentCardColors?: StudentCardColors;
  attendanceSchedule?: AttendanceSchedule;
}

export const DEFAULT_DAY_TIMES: AttendanceDayTimes = {
  checkInOpen: '07:00',
  checkInLateAfter: '07:45',
  checkOutOpen: '12:30',
  checkOutLateAfter: '13:30',
};

export const DEFAULT_HOLIDAY_WEEKDAYS = [0, 6];

export const DEFAULT_STUDENT_CARD_COLORS: StudentCardColors = {
  busBackground: '#e8f3ff',
  noBusBackground: '#fff7ed',
  cutMarginMm: 3.5,
};

@Injectable({
  providedIn: 'root'
})
export class SchoolSettingsService {
  private readonly url = ApiConstants.URL_SCHOOL_SETTINGS;

  constructor(private http: HttpClient) { }

  async get(): Promise<SchoolSettings> {
    const response = await firstValueFrom(this.http.get<any>(this.url));
    return response.data;
  }

  async update(body: SchoolSettings): Promise<SchoolSettings> {
    const response = await firstValueFrom(this.http.patch<any>(this.url, body));
    return response.data;
  }
}
